// src/components/HomeButtons.js
import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { SEAT_BOOKING_URL } from '../constants/venueLinks';

export default function HomeButtons({ openExternal }) {
  const [cmsItems, setCmsItems] = useState([]);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await axios.get('/api/public/cms-nav/list');
        if (!alive) return;
        const list = Array.isArray(data?.list) ? data.list : [];
        setCmsItems(
          list
            .filter((x) => x?.path && x?.title)
            .slice(0, 8)
            .map((x) => ({ label: `🧩 ${x.title}`, path: x.path }))
        );
      } catch {
        if (alive) setCmsItems([]);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  const items = useMemo(() => ([
    { label: '📋 方案介紹',        onClick: () => openExternal('https://tinybot.cc/thesingularity-tw/') },
    { label: '🪑 座位預約',        onClick: () => openExternal(SEAT_BOOKING_URL) },
   // { label: '🌙 取得夜間密碼',    onClick: () => (window.location.href = '/night') },
    { label: '🎉 活動資訊',        onClick: () => openExternal('https://tinybot.cc/thesingularity-tw/activity-3/') },
    { label: '💳 我的會員卡',      onClick: () => (window.location.href = '/card') },
    { label: '🎫 我的優惠券',      onClick: () => (window.location.href = '/coupons') },
    //{ label: '🍜 合作商家',        onClick: () => openExternal('https://tinybot.cc/thesingularity-tw/partnermerchant/') },
    ...cmsItems.map((x) => ({ label: x.label, onClick: () => (window.location.href = x.path) })),
  ]), [cmsItems, openExternal]);
  return (
    <section style={st.panel}>
      <div style={st.grid}>
        {items.map((x, i) => (
          <button key={i} onClick={x.onClick} style={st.btn}>{x.label}</button>
        ))}
      </div>
    </section>
  );
}

const st = {
  panel:{ background:'linear-gradient(180deg, #f4e8df 0%, #f0dfd4 100%)', borderRadius:18, padding:'14px 12px', boxShadow:'0 6px 14px rgba(0,0,0,.10)' },
  grid:{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 },
  btn:{ appearance:'none', width:'100%', minHeight:64, borderRadius:14, border:'0', background:'#fff',
        color:'#1c1b1a', fontSize:16, fontWeight:800, boxShadow:'0 2px 6px rgba(0,0,0,.06)' }
};
